// extracted by css-extract-rspack-plugin
export default {"heading":"heading-vbC1ht"};